import { render } from "./BuildBundleBanner.vue?vue&type=template&id=50871563&scoped=true"
import script from "./BuildBundleBanner.vue?vue&type=script&lang=js"
export * from "./BuildBundleBanner.vue?vue&type=script&lang=js"

import "./BuildBundleBanner.vue?vue&type=style&index=0&id=50871563&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50871563"]])

export default __exports__